import React, { useEffect, useCallback } from 'react';
import { defaultRouter } from 'app/common/router';
import parseTrelloUrl from 'app/scripts/lib/util/url/parse-trello-url';

import { CardBackHeader } from './CardBackHeader';
import { useMirrorCardQuery } from './MirrorCardQuery.generated';

import {
  useDialog,
  Dialog,
  DialogCloseButton,
} from 'app/src/components/Dialog';

import styles from './MirrorCard.less';

interface MirrorCardProps {
  idBoard: string;
  cardUrl: string;
}

export const MirrorCard = ({ cardUrl, idBoard }: MirrorCardProps) => {
  // We are confident that this is not undefined since before rendering
  // a mirror card in app/scripts/controller/display-board.js, we are
  // already on a valid card route
  const idCard = parseTrelloUrl(cardUrl).shortLink!;

  const { show, hide, dialogProps } = useDialog();

  const { data, loading } = useMirrorCardQuery({
    variables: {
      idCard,
    },
  });

  useEffect(() => {
    if (!loading) show();
  }, [show, loading]);

  const closeCardBack = useCallback(() => {
    hide();
    defaultRouter.setRoute(`/b/${idBoard}`);
  }, [hide, idBoard]);

  if (loading) return null;
  if (!data || !data.card) return null; // TODO goneill error states

  return (
    <Dialog
      className={styles.mirrorCard}
      size="large"
      {...dialogProps}
      hide={closeCardBack /* This must come after {...dialogProps} */}
    >
      <CardBackHeader
        boardName={data.card.board.name}
        cardName={data.card.name}
        listName={data.card.list.name}
      />
      <DialogCloseButton
        onClick={closeCardBack}
        className={styles.closeButton}
        size="medium"
      />
    </Dialog>
  );
};
